import { G_variables } from "../../../utils/globals/variables";
import { ENV_DEV } from "../../../utils/window";
import checkGlobalVariable from "./check-global-variable";
import replaceFoundString from "./replace-found-string";

/**
 * Replace variables in a string with the computed ones
 * @param {Array<String>} input
 * @param {Map<String, String>} store
 * @param {MainClassProps} main
 * @returns {Array<String>}
 */
const replaceVariables = (input, store, main) => {
  const result = [];

  /**
   * Single attribute from [data-tor]
   * @type {String}
   * @example `hover:tx($height)`
   */
  for (const attribute of input) {
    let string = attribute;

    /** Attribute includes variable */
    if (attribute.includes("$")) {
      /**
       * Match all variables in the string
       * @type {Array<String>}
       * @example `['$height']`
       */
      const matches = attribute.match(/\$+[\w-]+/g) || [];

      for (const match of matches) {
        const global = match.startsWith("$$");

        /**˙
         * Get variable from the store
         * @type {[MainClassProps, String] | undefined}
         * @example `$height` => `get(height)`
         */
        const find = global ? G_variables.get(match) : store.get(match);

        /** Variable definition found */
        if (find) {
          string = replaceFoundString(find[1], string, match, find[0]);
        } else {
          if (global) {
            checkGlobalVariable(main, match);
            continue;
          }

          if (ENV_DEV) {
            console.warn(
              `[TorusKit warn]: Cannot find a \`${match}\` variable definition`
            );
          }
        }
      }
    } else {
      /** No variable in an attribute */
      string = attribute;
    }

    result.push(string);
  }

  return result;
};

export default replaceVariables;
